import { StyleSheet } from 'aphrodite'

import main from './main'
import headers from './headers'
import lists from './lists'
import paragraphs from './paragraphs'
import sidebar from './sidebar'

export default {
  main: StyleSheet.create(main),
  headers: StyleSheet.create(headers),
  lists: StyleSheet.create(lists),
  paragraphs: StyleSheet.create(paragraphs),
  sidebar: StyleSheet.create(sidebar)
}



// WEBPACK FOOTER //
// ./src/components/Advertisers/style/index.js